// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

export type PillVariant = 'default';

@Component({
  selector: 'app-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pill.html',
})
export class Pill {
  // Inputs
  public text = input<string>('ENGINEERING');
  public variant = input<PillVariant>('default');

  public pillClasses = computed(() => {
    const base = [
      'flex',
      'flex-row',
      'items-center',
      'justify-start',
      'flex-nowrap',
      'h-fit',
      'w-fit',
      'pl-4',
      'pr-4',
      'pt-1',
      'pb-1',
      'rounded-xl',
      'border',
      'border-black',
      'bg-[#EEF4FD]',
    ];

    return base.join(' ');
  });
}
